const scaleFactor = 0.20;
const snapshots = [];
let interval = null;
let lastTime = null;

/**
 * Captures a image frame from the provided video element.
 *
 * @param {Video} video HTML5 video element from where the image frame will be captured.
 * @param {Number} scaleFactor Factor to scale the canvas element that will be return. This is an optional parameter.
 *
 * @return {Canvas}
 */

async function generateThumbnails(videoId, outputId) {
  return new Promise(async (resolve) => {
    const thumbnails = document.getElementById(outputId);
    thumbnails.innerHTML = '';

    const video = document.getElementById(videoId);
    while (video.duration === Infinity || isNaN(video.duration)) {
      // sleep for a 100ms, then try to find the end again
      await new Promise((r) => setTimeout(r, 100));
      video.currentTime = 10000000 * Math.random();
    }
    video.muted = true;
    const { duration } = video;
    video.currentTime = 0;

    // disable whole clip playthrough
    resolve();
    return;

    // play the whole clip first
    const picInterval = (duration / 21) / 15;
    video.playbackRate = 15;
    video.play();
    video.onended = function () {
      clearInterval(interval);
      video.currentTime = 0;
      video.playbackRate = 1;
      video.muted = false;
      video.onplay = null;
      resolve();
    };

    // disabling thumbnails themselves
    return;
    video.onplay = function () {
      interval = window.setInterval(() => {
        shoot(videoId, outputId);
      }, picInterval * 1000);
    };
  });
}

function capture(video, scaleFactor) {
  if (scaleFactor == null) {
    scaleFactor = 1;
  }
  const w = video.videoWidth * scaleFactor;
  const h = video.videoHeight * scaleFactor;
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(video, 0, 0, w, h);
  return canvas;
}

/**
 * Invokes the <code>capture</code> function and attaches the canvas element to the DOM.
 */
function shoot(videoId, outputId) {
  const video = document.getElementById(videoId);
  const output = document.getElementById(outputId);
  const canvas = capture(video, scaleFactor);

  if (lastTime == video.currentTime) return;
  lastTime = video.currentTime;

  canvas.setAttribute('data-timestamp', video.currentTime);
  canvas.onclick = function () {
    video.currentTime = canvas.getAttribute('data-timestamp');
    // window.open(this.toDataURL());
  };
  snapshots.push(canvas);

  const wrapper = document.createElement('div');
  wrapper.className = 'wrapper';
  wrapper.classList.add('animated');
  wrapper.classList.add('fadeIn');
  wrapper.classList.add('faster');
  wrapper.appendChild(canvas);
  const timecode = document.createElement('div');
  timecode.className = 'timecode';
  timecode.innerHTML = secondsToTimecode(video.currentTime);
  wrapper.appendChild(timecode);
  output.appendChild(wrapper);
}
async function captureFrameFromURL(url, currentTime) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = url;
    // video.crossOrigin = 'anonymous';
    video.currentTime = currentTime; // the thumbnail of the video is taken 1 second in
    video.onloadeddata = async () => {
      const canvas = capture(video, scaleFactor);
      try {
        const canvasURL = canvas.toDataURL();
        const thumbnail = await (await fetch(canvasURL)).blob();
        resolve(thumbnail);
      } catch (e) {
        reject();
      }
    };
  });
}

async function generateThumbnail(blob, currentTime = 1) {
  return new Promise((resolve) => {
    const blobURL = URL.createObjectURL(blob);
    captureFrameFromURL(blobURL, currentTime)
      .then((thumbnail) => {
        resolve(thumbnail);
      });
  });
}

function secondsToTimecode(seconds) {
  const _seconds = parseInt(seconds % 60);
  const minutes = parseInt(seconds / 60);
  return `${`${minutes}`.padStart(2, '0')}:${`${_seconds}`.padStart(2, '0')}`;
}

export { generateThumbnails, generateThumbnail, captureFrameFromURL };
